import MenuCloseIcon from './component'

export default MenuCloseIcon
